import { createReducer } from '../../helpers/reducer';
import { t } from '../../i18n';
import actions from './actions';

const initState = {
  action: undefined,
  loading: false,
  errors: [],
  redirectUrl: undefined,
};

function onSignIn(state) {
  return {
    ...state,
    errors: [],
    loading: true,
  };
}

function onSignInSuccess(state, { payload }) {
  return {
    ...state,
    redirectUrl: payload?.data?.redirect_to,
    errors: [],
  };
}

function onSignInFail(state, { payload }) {
  return {
    ...state,
    loading: false,
    errors: payload?.data?.errors?.messages || [t('dash.onBehalfOf.error_message')],
  };
}

export default createReducer(initState, {
  [actions.SIGN_IN_REQUEST]: onSignIn,
  [actions.SIGN_IN_SUCCESS]: onSignInSuccess,
  [actions.SIGN_IN_FAIL]: onSignInFail,
});
